import React, { useEffect, useState } from 'react'
import { Grid, Container, Box, Button, Typography, Alert, TextField } from '@mui/material'
import { computeDump, getDump } from './util'
import { type Translation, type LocalTranslation } from './model'
import { persistDump, queryDb } from './translation'

const TranslationSettings: React.FC = () => {
  const [errorMessage, setErrorMessage] = useState('') // add error state
  const [hasSoftError, setSoftError] = useState(false) // add error state
  const [successMessage, setSuccessMessage] = useState('') // add success state
  const [hasSuccessMessage, setHasSuccessMessage] = useState(false) // add success state
  const [query, setQuery] = useState('')
  const [results, setResults] = useState([] as Translation[])

  const handleQueryChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setQuery(event.target.value)
  }

  const handleQuerySubmit = () => {
    void queryDb(query).then(setResults)
  }

  const handleCreateDump = (): void => {
    computeDump()
      .then(() => {
        setSuccessMessage('Computed successfully!') // set success state if saveDefaults succeeds
        setSoftError(false)
        setHasSuccessMessage(true)
      })
      .catch(err => {
        setErrorMessage('Failed to compute ' + err) // set error state if saveDefaults fails
        setSoftError(true)
        setHasSuccessMessage(false)
      })
  }

  const handleFetchAndPersistDump = (): void => {
    console.log('starting to fetch and persist')
    getDump()
      .then(async (dump) => {
        console.log('successfully fetched dump. waiting to persist')
        await persistDump(dump)
        setHasSuccessMessage(true)
        // set success state if saveDefaults succeeds
        setSoftError(false)
        setSuccessMessage('Peristeing and saving successfull')
      })
      .catch(err => {
        setErrorMessage('Failed fetch and save dump: ' + err) // set error state if saveDefaults fails
        setSoftError(true)
        setHasSuccessMessage(false)
      })
  }

  return (
    <Container>
      {hasSoftError && <Alert severity="error">{errorMessage}</Alert>}
      {hasSuccessMessage && <Alert severity="success">{successMessage}</Alert>}
      <Grid container justifyContent="center">
        <Grid item xs={12} sm={8} md={6}>
          <Typography variant="h2">Translation Settings</Typography>
        </Grid>
        <Grid item xs={12} sm={8} md={6}>
          <Box marginBottom={2} display="flex" justifyContent="space-between">
            <Button onClick={handleCreateDump}>Create translation dump</Button>
            <Button onClick={handleFetchAndPersistDump}>Fetch and save translations from latest dump</Button>
          </Box>
        </Grid>
        <Grid item xs={12} sm={8} md={6}>
          <Box marginBottom={2} display="flex" justifyContent="space-between">
            <TextField value={query} onChange={handleQueryChange} />
            <Button onClick={handleQuerySubmit}>Translate</Button>
          </Box>
          {results.length > 0
            ? (
                results.map((translation: Translation, index: number) => (
      <Box key={index} marginBottom={2}>
        <Typography variant="h6">{translation.word}</Typography>
        <Typography variant="subtitle1">{translation.type}</Typography>
        <Typography>{translation.definition}</Typography>
      </Box>
                ))
              )
            : (
    <Typography>No results found</Typography>
              )}
    </Grid>
      </Grid>
    </Container>
  )
}

export default TranslationSettings
